<template>
  <div id="root">
    <div class="revcard" v-if="rev.sentscore != null && rev.sentlemma != null">
      <div class="row">
        <div class="col-md-6">
          <div class="revsite_icon">
            {{ review_site_logo }}
          </div>
        </div>
        <!-- 0-1 values of sentscore multiplied by 100 to make it percentage  -->
        <div class="col-md-6">
          <div class="rev_senti_score" :title="(rev.sentscore * 100).toFixed(2)">
             {{ rev.sentlabel }}
             <span v-if="rev.sentlabel == 'POSITIVE'">🙂</span>
             <span v-else>😕</span>
             
          </div>
        </div>
        <div>{{ year }}/{{ month }}</div>
        <div class="rev_text">
          <!-- Colorful Highlights-->

          <div class="m-1 p-4 revcard">

            <div class="colorful" v-if="rev['sentlemma']['sentiment'] != null">
              <!--item : sentence-->
              <span
                v-for="item in rev['sentlemma']['sentiment']"
                v-bind:key="item"
                :class="{ 
                   posh: item[1] > this.green_treshold, 
                   negh: item[1] < -this.red_treshold,
                   neuh: item[1] <= this.green_treshold & item[1] >= -this.red_treshold
                   }"
              >
                <span v-html="highlightSearchKeyword(item[0])"></span>

              <!-- Polarity scores -->
                (<span > % {{ (item['1']*100).toFixed(2)  }}</span>)

                <!-- End of the highlight tool -->
              </span>
            </div>
            <div v-else>Error while loading text.</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "RevCard",
  props: {
    review_site_logo: String,
    rev_senti_score: Number,
    rev: Object,
    year: Number,
    month: Number,
    searchKeyword: String,
    green_treshold: {
      type: Number,
      default: 0.4,
    },
    red_treshold: {
      type: Number,
      default: -0.4,
    },
  },
  computed: {},
  methods: {
    highlightSearchKeyword(sentence) {
      if (!this.searchKeyword) return sentence;

      const cleanedKeyword = this.searchKeyword.replace(/[^a-zA-Z]/g, "");
      const keywordRegex = new RegExp(cleanedKeyword, "gi");

      // Replace the searchKeyword with a highlighted version
      const highlightedSentence = sentence.replace(
        keywordRegex,
        (match) => `<b style="background-color:orange">${match}</b>`
      );

      return highlightedSentence;
    },
  },
};
</script>

<style scoped="scoped">
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@100&display=swap");

body {
  font-family: "Inter", sans-serif !important;
}

.negh {
  /**negative sentence highlight */
  background-color: #72062a;
  color: white;
  font-weight: bold;
}
.posh {
  background-color: #047486;
  color: white;
}

.neuh {
  background-color: white;
  color: rgb(14, 3, 3);
}

.revsite_icon {
  background-color: black;
  color: white;
  font-weight: bold;
  padding: 2px;
  margin: 2px;
  width: 180px;

  text-align: center;
}

.score_weak {
  background-color: rgba(204, 208, 230, 0.753);
  color: white;
  font-size: 0.8em;
  font-weight: bold;
  border-radius: 10px;
  margin-left: 10px;
  margin-right: 10px;
  padding: 2px;
  display: none;
}

.score {
  background-color: rgb(140, 90, 231);
  color: rgba(255, 255, 255, 0.537);
  font-size: 0.8em;
  font-weight: bold;
  border-radius: 10px;
  margin-left: 10px;
  margin-right: 10px;
  padding: 2px;
}
.score_sure {
  background-color: black;
  color: white;
  font-size: 0.8em;
  font-weight: bold;
  margin-left: 10px;
  margin-right: 10px;
  padding: 2px;
}
.rev_senti_score {
  color: #2b292a;
  font-weight: bold;
  font-size: large;
  text-align: right;
}
.revcard {
  padding: 1em;
  font-size: small;
  text-align: justify;
  margin-bottom: 1em;

  box-shadow: rgba(17, 17, 26, 0.1) 0px 4px 16px,
    rgba(17, 17, 26, 0.1) 0px 8px 24px, rgba(17, 17, 26, 0.1) 0px 16px 56px;
  line-height: 1.8em;
}
</style>
